// @ts-nocheck
/**
 * stringSelectRenderer.ts — Template V2 stringSelect component renderer.
 *
 * Decodes selection + options from a single encoded bound string.
 */

import { componentInteractionProps } from './interactionProps';
import { applyExpressionFallback, buildDescriptor, resolveValue } from './rendererUtils';
import type { CompiledPropsByType, ComponentRenderer } from './types';
import { extractTypedProps } from './types';
import {
  parseEncodedStringSelect,
} from '../stringSelect/encodedStringSelect';

export const STRING_SELECT_RENDERER: ComponentRenderer<CompiledPropsByType['stringSelect']> = {
  supportedType: 'stringSelect',
  render(context) {
    const issuesBefore = context.issues.length;
    const { visible, enabled } = applyExpressionFallback(context);
    const p = extractTypedProps('stringSelect', context.node.props);
    const encodedValue = resolveValue(p.stringSelect.source, context);
    const separator = p.stringSelect.separator;
    const parsed = parseEncodedStringSelect(encodedValue, separator);

    return buildDescriptor(context.node, visible, enabled, {
      encodedValue: encodedValue ?? null,
      selected: parsed.selected,
      options: [...parsed.options],
      separator: separator ?? ';',
      editable: p.stringSelect.editable ?? false,
      displayMode: p.stringSelect.displayMode ?? 'label',
      ...componentInteractionProps(context.node),
    }, { diagnostics: context.issues.slice(issuesBefore), renderContext: context });
  },
};
